import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import auth from '../actions/auth';
import AuthLayout from './AuthLayout';

const messageFor = (result) => {
  const msg = result && result.response && result.response.data && result.response.data.error
    ? result.response.data.error.message : '';
  if (msg.includes('Invalid identifier or password')) return 'That email and password don’t match. Check them and try again.';
  if (msg.includes('Incorrect params')) return 'Enter your email and password.';
  if (result && result.response && result.response.status === 429) return msg;
  return 'Couldn’t log in right now. Try again in a moment.';
};

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    const result = await auth.login(email, password);
    if (!result || result.status !== 200) {
      setError(messageFor(result));
      setBusy(false);
    }
  };

  return (
    <AuthLayout>
      <form onSubmit={onSubmit} noValidate>
        <h2>Log in</h2>
        <p className="lede">Use the email you registered with.</p>
        {error && <div className="form-error" role="alert">{error}</div>}
        <TextField label="Email or username" autoComplete="username" value={email} required autoFocus
          onChange={(e) => setEmail(e.target.value)} />
        <TextField label="Password" type="password" autoComplete="current-password" value={password} required
          onChange={(e) => setPassword(e.target.value)} />
        <Button type="submit" variant="contained" size="large" fullWidth disabled={busy || !email || !password}>
          {busy ? 'Logging in…' : 'Log in'}
        </Button>
        <div className="auth-links">
          <Link to="/forgot-password">Forgot password?</Link>
          <Link to="/register">Create an account</Link>
        </div>
      </form>
    </AuthLayout>
  );
};

export default LoginPage;
